<template functional>
    <span>
        <span class="red--text"><strong>* </strong></span>{{ props.name }}
    </span>
</template>
<script>
export default {
    functional: true,
    props: {
        name: String,
    },
}
</script>
